"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _constants = require("../../../constants");
const SnackStatusPrizm = props => _react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 30 30"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M15 21.75c3.7279221 0 6.75-3.0220779 6.75-6.75 0-3.72792206-3.0220779-6.75-6.75-6.75-3.72792206 0-6.75 3.02207794-6.75 6.75 0 3.7279221 3.02207794 6.75 6.75 6.75zm0-1.5c-2.89949494 0-5.25-2.35050506-5.25-5.25S12.10050506 9.75 15 9.75s5.25 2.35050506 5.25 5.25-2.35050506 5.25-5.25 5.25z"
}));
const SnackStatusMDS = props => _react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 8 8"
}, props), _react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
}));
const AbstractSnackStatus = ({
  theme,
  ...other
}) => theme.name === _constants.THEMES.mds ? _react.default.createElement(SnackStatusMDS, other) : _react.default.createElement(SnackStatusPrizm, other);
var _default = exports.default = (0, _styledComponents.withTheme)(AbstractSnackStatus);